import OrderStatus from '@/models/enums/OrderStatus'
import PaymentStatus from '@/models/enums/PaymentStatus'
import Role from '@/models/enums/Roles'
import kkmServerApiClient from '@/services/kkm-server/kkmServerApiClient'

export const CANCEL_FORBIDDEN_REASON = 'Отмена заказа ограничена администрацией ресторана, обратитесь к управляющему'
export const PAST_SHIFT_CANCEL_REASON = 'Заказ за прошлый день отменяет собственник, управляющий ' +
  'или сотрудник с отметкой «Может отменять заказы за прошлые дни»'
export const PAST_SHIFT_REFUND_REASON = 'Возврат по заказу за прошлый день делает собственник, управляющий ' +
  'или сотрудник с отметкой «Может отменять заказы за прошлые дни»'

// причина, по которой кнопка отмены неактивна; null - отменять можно. Флаги сотрудника - геттер auth/orderCancelFlags.
// Порядок как в OrderCancelGuard на бэке: запрет сотрудника, прошлая смена (isPastShift считает бэк, пускает право
// CancelPastShiftOrders или флаг сотрудника canCancelPastShiftOrders), колл-центр. Смену и ПК точки фронт не знает -
// их отказ объясняет текст 403. Зеркало правила колл-центра неточное: бэк смотрит последний успешный платёж, здесь - последний
// платёж вообще; разойдутся только при второй строке платежа рядом с живым success - тогда кнопка активна,
// а бэк ответит 403 с текстом
export function cancelRestrictionReason (order, { isCallCenter = false, cancelForbidden = false, canCancelPastShift = false } = {}) {
  if (cancelForbidden) {
    return CANCEL_FORBIDDEN_REASON
  }

  if (order?.isPastShift && !canCancelPastShift) {
    return PAST_SHIFT_CANCEL_REASON
  }

  if (!isCallCenter) {
    return null
  }

  if (order?.orderStatus === OrderStatus.Completed) {
    return 'Завершённый заказ отменяет филиал'
  }

  if (order?.payment?.status === PaymentStatus.Success) {
    return 'Оплаченный заказ отменяет филиал'
  }

  return null
}

// причина, по которой неактивна кнопка возврата без отмены заказа («Отменить платеж»); null - можно.
// Зеркало OrderCancelGuard::assertCanRefund: только прошлая смена. Закрепление админа за филиалом фронт не знает -
// отказ по чужому филиалу объясняет текст 403
export function refundRestrictionReason (order, { canCancelPastShift = false } = {}) {
  return order?.isPastShift && !canCancelPastShift ? PAST_SHIFT_REFUND_REASON : null
}

// Роли с правом CancelPastShiftOrders (суперадмин - через Gate::before) и без проверки смены и ПК точки
export const MANAGER_ROLES = [Role.SuperAdmin, Role.OrganizationOwner, Role.OrganizationDirector]

// Админ филиала отменяет только с ПК точки: перед отменой CRM проверяет ККМ-сервер этого компьютера.
// Проверка только на фронте - бэк ПК точки не видит; управляющих правило не касается
export function needsPointKkmCheck (roles) {
  if (!Array.isArray(roles) || !roles.includes(Role.FilialAdmin)) {
    return false
  }

  return !roles.some(role => MANAGER_ROLES.includes(role))
}

// Перед каждым запросом с отменой заказа (orders/{id}/cancel, возврат с cancelOrder). Причина отказа или null:
// на этом ПК включена интеграция с ККМ-сервером и он отвечает. getters - корневые геттеры store
export async function orderCancelPointError (getters) {
  if (!needsPointKkmCheck(getters['auth/getRoles'])) {
    return null
  }

  if (!getters['printServer/isKkmServerProxyEnabled']) {
    return 'Отменить заказ можно только с компьютера точки: включите интеграцию с ККМ-сервером в настройках'
  }

  try {
    await kkmServerApiClient.probe()
  } catch (e) {
    return 'ККМ-сервер на этом компьютере не отвечает: отменить заказ можно только с компьютера точки'
  }

  return null
}
